import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { faCheck, faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SaveMessage = (props) => {
  const { className, message, ...htmlProps } = props;
  if (!message) return null;

  let messageClass, messageIcon;

  switch (message.type) {
  case 'error': {
    messageClass = 'text-danger';
    messageIcon = faExclamationCircle;
    break;
  }
  case 'success': {
    messageClass = 'text-success';
    messageIcon = faCheck;
    break;
  }
  }

  return (
    <p className={classNames([messageClass, className])} {...htmlProps}>
      <FontAwesomeIcon icon={messageIcon} />
      <span className="ms-2">{message.text}</span>
    </p>
  );
};

SaveMessage.propTypes = {
  className: PropTypes.any,
  message: PropTypes.shape({
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['error', 'success']).isRequired
  })
};

export default SaveMessage;
